import { render, staticRenderFns } from "./BookingCalendar.vue?vue&type=template&id=185da1e3"
import script from "./BookingCalendar.vue?vue&type=script&lang=ts"
export * from "./BookingCalendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports